import { useTranslation } from "react-i18next";
import ExpandableText from "../../../../components/app/ExpandableText";
import ScientificText from "../../../../components/ScientificText";
import type { ArticlePageArticle } from "../../hooks/useArticleData";
import { SectionTitle } from "../../../../components/ui/SectionTitle";

interface ArticleSectionObjectivesProps {
  article: ArticlePageArticle;
  isExpanded: boolean;
  setExpand: (isExpanded: boolean) => void;
}

export function ArticleSectionObjectives({
  article,
  isExpanded,
  setExpand,
}: ArticleSectionObjectivesProps) {
  const { t } = useTranslation();
  const objectives = article.objectives.filter((el) => el !== "");

  if (objectives.length === 0) return null;

  return (
    <section data-gtm-section="objectives" data-gtm-order="3">
      <SectionTitle title={t("Objectives")} className="mb-4" />
      <ExpandableText
        isExpanded={isExpanded}
        setExpand={setExpand}
        lines={10}
        variant="list"
      >
        <ul>
          {objectives.map((el, index) => (
            <li key={index}>
              <ScientificText>{el}</ScientificText>
            </li>
          ))}
        </ul>
      </ExpandableText>
    </section>
  );
}
